export var monthNames = ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'];
export var weekDayNames = ['周一', '周二', '周三', '周四', '周五', '周六', '周日'];
export var monthNamesJpa = ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'];
export var weekDayNamesJpa = ['月', '火', '水', '木', '金', '土', '日'];